import * as React from 'react';

import { Button, MenuItem, Select, TextField } from '@material-ui/core';
import { withRouter } from 'react-router-dom';

import { extendSearch, getSortingValue, sortOptions } from './helpers';
import { IProps, IState } from './interfaces';

import styles from './SearchForm.module.styl';

const ENTER_CHAR_CODE = 13;

class SearchForm extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);

    const { location } = props;

    const sortedOption = getSortingValue(this.props.location.search);

    if (location.pathname.includes('/search')) {
      this.state = {
        sortedOption,
        value: decodeURI(location.hash.split('#')[1] || ''),
      };

      return;
    }
    this.state = {
      sortedOption,
      value: '',
    };
  }

  public componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any,
  ): void {
    if (
      this.props.location.search !== prevProps.location.search &&
      this.props.location.search === ''
    ) {
      this.setState({
        sortedOption: getSortingValue(this.props.location.search),
        value: decodeURI(this.props.location.hash.split('#')[1] || ''),
      });
    }
  }

  public handleSorting = (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({ sortedOption: event.target.value as string }, () => {
      this.redirect();
    });
  };

  public render() {
    const { value, sortedOption } = this.state;

    return (
      <div className={styles.root}>
        <Select
          value={sortedOption}
          onChange={this.handleSorting}
          variant="outlined"
          className={styles.select}
          placeholder="Sort by"
        >
          {sortOptions.map((option: any) => {
            return (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            );
          })}
        </Select>
        <TextField
          className={styles.input}
          value={value}
          placeholder="Search"
          margin="dense"
          onChange={this.onChange}
          onKeyPress={this.handleKeyPress}
          variant="outlined"
        />
        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={this.handleClick}
          disabled={!Boolean(value)}
        >
          Search
        </Button>
      </div>
    );
  }

  private readonly handleClick = (): void => {
    const {
      history,
      match: { params },
      location,
    } = this.props;
    const { value } = this.state;

    const search = extendSearch(location.search, this.state.sortedOption);

    history.push(
      `${
        params && params.locale ? `/${params.locale}` : ''
      }/search${search}#${value.trim()}`,
    );
  };

  private readonly redirect = (): void => {
    const { history, location } = this.props;

    const search = extendSearch(location.search, this.state.sortedOption);

    history.push(`${location.pathname}${search}${location.hash}`);
  };

  private readonly handleKeyPress = (
    e: React.KeyboardEvent<HTMLDivElement>,
  ): void => {
    if (e.charCode === ENTER_CHAR_CODE) {
      const {
        history,
        match: { params },
        location,
      } = this.props;
      const { value } = this.state;

      const search = extendSearch(location.search, this.state.sortedOption);

      history.push(
        `${
          params && params.locale ? `/${params.locale}` : ''
        }/search${search}#${value.trim()}`,
      );
    }
  };

  private readonly onChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    this.setState({
      value: e.target.value,
    });
  };
}

export default withRouter(SearchForm);
